import React from 'react';
import { Link } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import { Footer, Header } from '../Common';
import { SideBar } from '../Common/SideBar';
import Chat from '../../Models/Chat';
import axios from 'axios';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
class SellerDirectMessage extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 2) {
            alert('ログインしてください')
            window.location.href = '/login/seller';
        };
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        // var url = decodeURIComponent(this.props.match.params.id).split('/')
        // var seller_id = url[url.length - 1]
        // var buyer_id = url[url.length - 2]
        // console.log(seller_id)
        // console.log(buyer_id)
        this.state = {
            conversation: [],
            other: [],
            content: '',
            seller: '',
            buyer: '',
            sender: '',
            receiver: '',
            user: logged_user.id,
            userImage: logged_user.img_sidebar,
            attchmnt: null
        }
        SimpleReactValidator.addLocale('klingon', {
            integer: '数字を入れてください.',
            max: ':attribute :max 文字以下にしてください .',
            required: ' :attribute を必須です.',
            min: ':attribute :min 文字以上にしてください .',
        });
        this.validator = new SimpleReactValidator({
            locale: 'klingon',
        })
        this.getData();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location.state.buyer_id || nextProps.location.state.buyerId) {
            if (this.state.user === nextProps.location.state.buyerId) {
                Chat.getConversationBuyer(nextProps.location.state.buyer_id, nextProps.location.state.seller_id).then(res => {
                    this.setState({ conversation: res.data.payload })
                    this.setState({ other: res.data.other_side })
                    this.setState({ seller: this.props.location.state.seller_id })
                    this.setState({ buyer: this.props.location.state.buyer_id })
                    this.setState({ sender: this.state.user })
                    if (this.state.sender === this.props.location.state.buyer_id) {
                        this.setState({ receiver: this.props.location.state.seller_id })
                    } else {
                        this.setState({ receiver: this.props.location.state.buyer_id })
                    }
                })
            } else {
                Chat.getConversationSeller(nextProps.location.state.buyer_id, nextProps.location.state.seller_id).then(res => {
                    this.setState({ conversation: res.data.payload })
                    this.setState({ other: res.data.other_side })
                    this.setState({ seller: this.props.location.state.seller_id })
                    this.setState({ buyer: this.props.location.state.buyer_id })
                    this.setState({ sender: this.state.user })
                    if (this.state.sender === this.props.location.state.buyer_id) {
                        this.setState({ receiver: this.props.location.state.seller_id })
                    } else {
                        this.setState({ receiver: this.props.location.state.buyer_id })
                    }
                })
            }
        }
        // window.location.reload()
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    getData() {
        console.log(this.props.location.state)
        if (this.state.user === this.props.location.state.buyer_id) {
            Chat.getConversationBuyer(this.props.location.state.seller_id, this.props.location.state.buyer_id).then(res => {
                this.setState({ conversation: res.data.payload })
                this.setState({ other: res.data.other_side })
                this.setState({ seller: this.props.location.state.seller_id })
                this.setState({ buyer: this.props.location.state.buyer_id })
                this.setState({ sender: this.state.user })
                if (this.state.sender === this.props.location.state.buyer_id) {
                    this.setState({ receiver: this.props.location.state.seller_id })
                } else {
                    this.setState({ receiver: this.props.location.state.buyer_id })
                }
            })
        } else {
            Chat.getConversationSeller(this.props.location.state.buyer_id, this.props.location.state.seller_id).then(res => {
                this.setState({ conversation: res.data.payload })
                this.setState({ other: res.data.other_side })
                this.setState({ seller: this.props.location.state.seller_id })
                this.setState({ buyer: this.props.location.state.buyer_id })
                this.setState({ sender: this.state.user })
                if (this.state.sender === this.props.location.state.buyer_id) {
                    this.setState({ receiver: this.props.location.state.seller_id })
                } else {
                    this.setState({ receiver: this.props.location.state.buyer_id })
                }
            })
        }
    }

    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
        console.log(this.state.modal)
    }

    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    onChangePro(e) {
        this.setState({ attchmnt: e.target.files[0] })
    }

    handleSubmit(e) {
        // document.getElementById("snd_msg").disabled = true;
        e.preventDefault();
        if (this.state.content !== null && this.state.content !== '') {
            console.log('message')
            const formData = new FormData();
            formData.append('attchmnt', this.state.attchmnt)
            formData.append('seller', this.state.seller)
            formData.append('buyer', this.state.buyer)
            formData.append('content', this.state.content)
            formData.append('sender', this.state.sender)
            formData.append('receiver', this.state.receiver)
            axios({
                method: 'post',
                url: 'https://share-work.jp/backend/store-msg',
                // url: 'http://192.168.1.110/sharework_back_v2/public/backend/store-msg',
                // url: 'http://share-work.jp/backend/update-basic-profile',
                data: formData,
                config: {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                }
            }).then(res => {
                if (res.data.status === 200) {
                    alert("メッセージ送信されました!")
                    window.location.reload()
                }
            })
        } else {
            // alert("メッセージを必須です.")
            // console.log('message not')
            this.setState({ 
                modal: !this.state.modal
              },() => {setTimeout(this.toggle.bind(this), 3000)});
        }
    }
    render() {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile responsive
        if (isMobile) {
            return (
                <div>
                    <Modal size='sm' isOpen={this.state.modal} modalTransition={{ timeout: 1 }} backdropTransition={{ timeout: 5 }} toggle={this.toggle.bind(this)}>
                        <ModalBody>
                            メッセージを入力してください
                           </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.toggle.bind(this)}>キャンセル</Button>
                        </ModalFooter>
                    </Modal>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div> */}
                            <div className="col-md-8">
                                <div className=" row">
                                    <div className="col-10" style={{ paddingLeft: "22px" }}>
                                        <div className="mt-5 input_name big_font" style={{ width: '100%', textAlign: 'left', fontSize: '20px' }}>
                                            ダイレクトメッセージ詳細
                                        </div>
                                    </div>
                                    <div className="col-2 mt-5">
                                        <Link to={'/seller-direct-message-list'} className="text-right return_text mt-5 mb-3">
                                            <img src={require("../../assets/images/Easy_Returns-512.png")} alt="" className="" alt="" style={{ width: "30px", height: "30px" }} />
                                        </Link>
                                    </div>
                                </div>
                                <div className="m-2 mt-0" style={{ height: "auto !important", border: "1px solid #e6e6e6", padding: "3%", minHeight: "1100px", overflow: "auto" }}>
                                    <div className="m-2 row">
                                        <div className="col-md-12" style={{ border: "1px solid #e6e6e6", padding: "2%", borderRadius: "5px" }}>
                                            <div className="col-md-8 m-2">
                                                <div className="user_message" style={{ fontSize: '14px' }}>
                                                    <b><i>{this.state.other.first_name}</i></b>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.conversation.map(conv =>
                                        <div className="m-2">
                                            <div className="row">
                                                {/* <div className="col-md-2 mini_pad">
                                                    <img src={conv.img_sender} className=" rounded-circle" alt="" width="70" height="70" /><br />
                                                </div> */}
                                                <div className="col-md-7 ">
                                                    <div className="message_name_text">
                                                        <span><b>{conv.sender}</b></span><br />
                                                    </div>
                                                    <div className="product_description">
                                                        {conv.content.split('\n').map(function (item, key) {
                                                            return (
                                                                <span key={key}>
                                                                    {item}
                                                                    <br />
                                                                </span>
                                                            )
                                                        })}
                                                    </div>
                                                    {(() => {
                                                        if (conv.file !== '') {
                                                            return (
                                                                <div style={{ fontSize: "13px" }}>
                                                                    <a href={conv.attchmnt} target="_blank">{conv.file}</a>
                                                                </div>
                                                            )
                                                        } else {
                                                            return (
                                                                <div></div>
                                                            )
                                                        }
                                                    })()}
                                                    <div className="message_open_time">
                                                        &nbsp;
                                                            </div>
                                                </div>
                                                <div className="col-md-3 message_time">
                                                    {(JSON.stringify(conv.created_at)).substring(1, 11)}
                                                </div>
                                            </div>
                                            <hr />
                                        </div>
                                    )}
                                    <div className="m-2">
                                        <div className="row">
                                            {/* <div className="col-md-2 mini_pad">
                                                <img src={this.state.userImage} className=" rounded-circle" alt="" width="70" height="70" style={{ objectFit: 'cover' }} /><br />
                                            </div> */}
                                            <div className="col-md-10" style={{ borderRadius: "0px" }}>
                                                <div className="row row_edit" >
                                                    <div className="col-md-3 message text-left" style={{ borderRadius: "0px", fontSize: '12px' }}>
                                                        <span className=""><b>メッセージ</b></span><br />
                                                    </div>
                                                </div>
                                                <div className="message_form" style={{ borderRadius: "0px", padding: "2%" }}>
                                                    <textarea style={{ border: "1px solid gray" }} className="message_textarea m-2"
                                                        value={this.state.content} onChange={this.updateValue.bind(this, 'content')}>
                                                    </textarea>
                                                    <input style={{ fontSize: "13px", paddingLeft: '10px' }} type="file" onChange={this.onChangePro.bind(this)}></input>
                                                </div>
                                                <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('メッセージ', this.state.editor_msg, 'required|min:1|max:500')}</span>
                                            </div>
                                        </div>
                                        <div className="text-center p-3 " >
                                            <button id="snd_msg" onClick={this.handleSubmit.bind(this)} type="submit" className="btn btn-lg " style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} >
                                                <span className="fa fa-check"></span>
                                                送信する
                                                    </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div>
                    <Modal size='sm' isOpen={this.state.modal} modalTransition={{ timeout: 1 }} backdropTransition={{ timeout: 5 }}
                        toggle={this.toggle.bind(this)}>
                        {/* <ModalHeader toggle={this.toggle.bind(this)}>Modal title</ModalHeader> */}
                        <ModalBody>
                            メッセージを必須です
                           </ModalBody>
                        <ModalFooter>
                            {/* <Button color="primary" onClick={this.toggle.bind(this)}>Do Something</Button>{' '} */}
                            <Button color="secondary" onClick={this.toggle.bind(this)}>キャンセル</Button>
                        </ModalFooter>
                    </Modal>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className=" row">
                                            <div className="col-md-10" style={{ paddingLeft: "22px" }}>
                                                <div className="mb-1 input_name big_font text-left" style={{ width: '100%' }}>
                                                    ダイレクトメッセージ詳細
                                            </div>
                                            </div>
                                            <div className="col-md-2" style={{ paddingLeft: '33px' }} >
                                                <Link to={'/seller-direct-message-list'} className="col-md-5 text-right return_text mt-5 mb-3">
                                                    <img src={require("../../assets/images/Easy_Returns-512.png")} alt="" className="" alt="" style={{ width: "30px", height: "30px" }} />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="mb-2 ml-2 mr-2 mt-0" style={{ height: "auto !important", border: "1px solid #e6e6e6", padding: "3%", height: "1100px", overflow: "auto" }}>
                                            <div className="m-2 row">
                                                <div className="col-md-12 row" style={{ border: "1px solid #e6e6e6", padding: "2%", borderRadius: "5px" }}>
                                                    <div className="col-md-8 m-2">
                                                        <div className="user_message">
                                                            <b><i>{this.state.other.first_name}</i></b>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>&nbsp;</div>
                                            {this.state.conversation.map(conv =>
                                                <div className="m-2">
                                                    <div className="row">
                                                        <div className="col-md-2 mini_pad">
                                                            <img src={conv.img_sender} className=" rounded-circle" alt="" width="70" height="70" /><br />
                                                        </div>
                                                        <div className="col-md-7 ">
                                                            <div className="message_name_text">
                                                                <span><b>{conv.sender}</b></span><br />
                                                            </div>
                                                            <div className="product_description">
                                                                {conv.content.split('\n').map(function (item, key) {
                                                                    return (
                                                                        <span key={key}>
                                                                            {item}
                                                                            <br />
                                                                        </span>
                                                                    )
                                                                })}
                                                            </div>
                                                            {(() => {
                                                                if (conv.file !== '') {
                                                                    return (
                                                                        <div style={{ fontSize: "13px" }}>
                                                                            <a href={conv.attchmnt} target="_blank">{conv.file}</a>
                                                                        </div>
                                                                    )
                                                                } else {
                                                                    return (
                                                                        <div></div>
                                                                    )
                                                                }
                                                            })()}
                                                            <div className="message_open_time">
                                                                &nbsp;
                                                        </div>
                                                        </div>
                                                        <div className="col-md-3 message_time">
                                                            {(JSON.stringify(conv.created_at)).substring(1, 11)}
                                                        </div>
                                                    </div>
                                                    <hr />
                                                </div>
                                            )}
                                            <div className="m-2">
                                                <div className="row">
                                                    <div className="col-md-2 mini_pad">
                                                        <img src={this.state.userImage} className=" rounded-circle" alt="" width="70" height="70" style={{ objectFit: 'cover' }} /><br />
                                                    </div>
                                                    <div className="col-md-10" style={{ borderRadius: "3px" }}>
                                                        <div className="row row_edit" >
                                                            <div className="col-md-3 message text-center" style={{ paddingLeft: '3px', borderRadius: "3px" }}>
                                                                <span className=""><b>メッセージ</b></span><br />
                                                            </div>
                                                            <div className="col-md-9" style={{ borderBottom: "1px solid #ccc" }}>

                                                            </div>
                                                        </div>
                                                        <div className="message_form" style={{ borderRadius: "3px", padding: "2%" }}>
                                                            <textarea style={{ border: "1px solid gray" }} className="message_textarea m-2"
                                                                value={this.state.content} onChange={this.updateValue.bind(this, 'content')}>
                                                            </textarea>
                                                            <div className="col-md-12" style={{ paddingLeft: '9px' }}>
                                                                <input style={{ fontSize: "13px" }} type="file" onChange={this.onChangePro.bind(this)}></input>
                                                            </div>
                                                        </div>
                                                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('メッセージ', this.state.editor_msg, 'required|min:1|max:500')}</span>
                                                    </div>

                                                </div>

                                                <div className="text-center p-3 " >
                                                    <button id="snd_msg" onClick={this.handleSubmit.bind(this)} type="submit" className="btn btn-lg " style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} >
                                                        <span className="fa fa-check"></span>
                                                        送信する
                                            </button>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { SellerDirectMessage }